import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import heroimg from '../../assest/ExamSify Png.png'
import searchiconimg from '../../assest/search icon.png'

const Hero = () => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = () => {
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };
  const enterkey = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }
  return (
    <>
      <div className='hero-container'>
        <div className='hero-wrapper'>
          <h1>ExamSify</h1>
          <p>PAST PAPERS FOR FUTURE SUCCESS</p>
          <div className="search-bar-container">
            <input
              type="text"
              placeholder="Type Your Question"
              className="search-bar"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={enterkey}
            />
            <img src={searchiconimg} alt="search" className="search-icon" />
          </div>

          <button className='search-btn' onClick={handleSearch}>Search Solution</button>
        </div>
        <img src={heroimg} className='hero-img' />
      </div>
    </>
  );
};

export default Hero;
